/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Sharp_Newt_MendInputs */

const en_fair_sharp_newt_mend = /** @type {(inputs: Fair_Sharp_Newt_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared Content`)
};

const de_fair_sharp_newt_mend = /** @type {(inputs: Fair_Sharp_Newt_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geteilte Inhalte`)
};

/**
* | output |
* | --- |
* | "Shared Content" |
*
* @param {Fair_Sharp_Newt_MendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_sharp_newt_mend = /** @type {((inputs?: Fair_Sharp_Newt_MendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Sharp_Newt_MendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_sharp_newt_mend(inputs)
	return de_fair_sharp_newt_mend(inputs)
});